import { isAfter } from 'date-fns';
import { Company } from '../types/company';

export const checkIsTrial = (company: Company | undefined) => {
  if (!company) return false;

  return company?.trial_end_at && !isAfter(new Date(), new Date(company?.trial_end_at!));
};
